import Lottie from 'lottie-react';
import useLottieJson from '../../hooks/useLottieJson';

/**
 * Título de sección: puede ser una imagen estática o un Lottie (.json de After
 * Effects), según `type`. Reusa el patrón del PromotionsBanner para el Lottie.
 */
function SectionTitle({ url, type }) {
  const anim = useLottieJson(type === 'lottie' ? url : null);

  if (!url) return null;

  if (type === 'lottie') {
    if (!anim) return null;
    const w = anim.w || 600;
    const h = anim.h || 200;
    return (
      <div style={{ height: 56, width: 56 * (w / h) }}>
        <Lottie animationData={anim} loop autoplay className="w-full h-full" />
      </div>
    );
  }

  return <img src={url} alt="" className="h-20 w-auto object-contain" />;
}

/**
 * Sección reutilizable del home: imagen de fondo + título (imagen o Lottie) +
 * contenido (children, normalmente una fila de productos). Se usará para
 * Populares y futuras secciones.
 */
export default function HomeSection({ backgroundImage, titleUrl, titleType = 'image', children }) {
  return (
    <section
      className="relative bg-cover bg-center py-5"
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined}
    >
      {titleUrl && (
        <div className="px-4 mb-3 flex justify-center">
          <SectionTitle url={titleUrl} type={titleType} />
        </div>
      )}
      {children}
    </section>
  );
}
